import React, { memo } from 'react';

interface MemoButtonProps {
    hasMemo: boolean;
    onClick: () => void;
}

const MemoButton: React.FC<MemoButtonProps> = ({ hasMemo, onClick }) => {
    return (
        <button
            className={`rounded-sm w-8 h-8 ${
                hasMemo 
                    ? "" 
                    : "border border-custom-dark opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            }`}
            onClick={onClick}
        >
            {hasMemo ? '📝' : '+'}
        </button>
    );
};

export default memo(MemoButton);
